import React from 'react';

/**
 * Reusable metric card component for displaying inventory statistics
 *
 * @param {Object} props
 * @param {string} props.title - Card title (displayed in uppercase gray)
 * @param {string|number} props.value - Main metric value
 * @param {string} [props.subtitle] - Optional subtitle text below value
 * @param {string} [props.valueColor] - Optional color class for value (e.g., 'text-blue-600', 'text-red-600')
 */
function MetricCard({ subtitle, title, value, valueColor = 'text-gray-900' }) {
    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 text-left shadow-sm">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">{title}</div>
            <div className={`text-3xl font-bold ${valueColor} mb-1 tabular-nums`}>
                {typeof value === 'number' ? value.toLocaleString() : value}
            </div>
            {subtitle && <div className="text-sm text-gray-500">{subtitle}</div>}
        </div>
    );
}

export default MetricCard;
